<template>
  <div class="list-page">
    <div class="header">
      <span class="title2">申报列表</span>
      <el-button type="primary" size="small" @click="handleAdd">新增申报</el-button>
    </div>
    <el-table
      :data="tableList"
      border
      stripe
      :header-cell-style="{
        'font-size': '14px',
        color: '#909399',
        'font-weight': '400',
        background: '#F7F8FA',
      }"
      v-loading="loading"
      style="width: 100%; margin-top: 20px;"
      header-cell-class-name="custom-header"
    >
      <el-table-column prop="createdAt" align="center" label="发布时间" />
      <el-table-column prop="title" align="center" label="申报标题"/>
      <el-table-column prop="applyTime" align="center" label="申报时间" width="360">
        <template slot-scope="scope">
          {{ scope.row.startTime }} 至 {{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column label="申报人数" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.submitCount }}</div>
          <el-button type="text" @click="handleDetail(scope.row)" style="margin-left: 8px;">查看详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)" style="margin-left: 8px;color: #F0232D;">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="tableList.length > 0" class="flex_end p-sm flexRowCenter">
      <el-pagination
        @current-change="getList"
        @size-change="changePageGetList"
        :current-page.sync="search.page"
        :page-size="search.pageSize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="count">
      </el-pagination>
    </div>
    <PartyMemberDetailDialog
      :visible.sync="detailDialogVisible"
      :detailId="detailId"
      @close="closeDetailDialog"
    />
  </div>
</template>

<script>
import PartyMember from '@/axios/api/partyMember.js'
import PartyMemberDetailDialog from './detail.vue'
export default {
  name: 'PartyMemberList',
  components: {
    PartyMemberDetailDialog
  },
  data() {
    return {
      tableList: [],
      search: {
        type: "",
        status: "",
        name: "",
        page: 1,
        pageSize: 10,
        start: '',
        end: ''
      },
      loading: false,
      count: 0,
      detailDialogVisible: false,
      detailId: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    closeDetailDialog() {
      this.detailDialogVisible = false
      console.log('closeDetailDialog');
    },
    // 页大小改变请求列表数据
    changePageGetList(size){
      this.search.pageSize = size
      this.getList(1)
    },
    async getList(i) {
      if (i) {
        this.search.page = i;
      }
      this.loading = true
      let res = await PartyMember.getDeclareList(this.search)
      this.loading = false
      if (res.status == 1) {
        res.data = res.data || []
        this.tableList = res.data || []
        this.count = res.extra.count
      }
    },
    formatDate(ts) {
      if (!ts) return '-'
      const d = new Date(ts)
      const y = d.getFullYear()
      const m = (d.getMonth() + 1).toString().padStart(2, '0')
      const day = d.getDate().toString().padStart(2, '0')
      //精确到时间
      const h = d.getHours().toString().padStart(2, '0')
      const mm = d.getMinutes().toString().padStart(2, '0')
      const s = d.getSeconds().toString().padStart(2, '0')
      return `${y}-${m}-${day} ${h}:${mm}:${s}`
    },
    handleAdd() {
      this.$router.push({
        path: '/partyMember/edit',
        query: {}
      })
    },
    handleEdit(row) {
      this.$router.push({
        path: '/partyMember/edit',
        query: {
          id: row.id
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该申报吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        let res = await PartyMember.deleteDeclare(row.id)
        if (res.status == 1) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    handleDetail(row) {
      this.detailId = row.id
      this.detailDialogVisible = true
    }
  }
}
</script>

<style scoped>
.list-page {
  background: #e9eff6;
  min-height: 100vh;
  padding: 24px;
}
.header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.title2 {
  font-size: 18px;
  font-weight: bold;
  margin-right: 16px;
}
.custom-header {
  background: #f5f8fa !important;
  color: #8c98a6 !important;
  font-weight: bold;
  font-size: 14px;
}
.el-button--danger {
  color: #f56c6c !important;
}
.flexRowCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
